var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-278 370 54 54",
    style: {
      enableBackground: "new -278 370 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#298BC1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-228,394.5c-0.8-3.8-2.5-7.2-5.2-10.2c-0.1-0.1-0.3-0.2-0.4-0.2s-0.4,0.1-0.4,0.2l-2.4,3 c-0.2,0.2-0.2,0.4,0,0.7l0.5,0.9c1.8,2.7,2.6,5.7,2.8,8.7c0.4,5.7-1.6,10.6-5.6,14.7c-0.8,0.8-1.2,1.8-1.2,2.7 c0,0.9,0.4,1.7,1.1,2.3c0.6,0.6,1.4,0.9,2.2,0.9h0.1c1,0,1.9-0.5,2.6-1.3C-228.1,410.3-226.1,402.8-228,394.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-239.1,379.9L-239.1,379.9c0.1-0.4,0-0.6-0.3-0.8c-8.5-5.4-22.3-4.8-30.4,5.6c-7.5,9.6-5.5,22.4,0.7,28.7 c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1c0.3-0.1,0.4-0.4,0.3-0.6c-0.1-0.3-0.2-0.5-0.4-0.7c-2.3-3.1-3.6-6.6-3.9-10.3 c-0.6-7.4,1.9-13.3,7.4-17.6c6.1-4.9,13.4-5.9,20.9-2.8c1.3,0.5,2.4,1.1,2.4,1.1c0.3,0.1,0.5,0.1,0.7-0.2c0,0,0.8-1,1.8-2.1 C-239.2,380.2-239.1,380-239.1,379.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-235.5,379.9c0.4,0.4,0.7,0.7,1.1,1.1c-1.3,1.6-2.5,3.2-3.9,4.8c-3.4,4.3-6.9,8.6-10.3,12.9 c-0.2,0.3-0.4,0.6-0.4,1c-0.2,1.6-1.4,2.8-2.9,2.8s-2.7-1.1-3-2.5c-0.2-1.4,0.8-2.7,2.2-3.2c0.5-0.2,1.1-0.5,1.6-0.9 c4.9-5,9.7-10,14.6-15.1C-236.1,380.4-235.8,380.3-235.5,379.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.41663f0e837294a30ea9b446c3d6da21.svg";
export { ForwardRef as ReactComponent };